export const SeccionesPreestablecidas = [
	{
		título: 'Texto',
		ícono: 'mdi-format-text',
		//imagenSVG: `<svg xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" style="display: block;" width="108px" height="74px" viewBox="0 0 108 74" version="1.1" focusable="false" id="svg28" sodipodi:docname="pruebaSVG.svg" inkscape:version="0.92.3 (2405546, 2018-03-11)"> <defs id="defs3"> <rect id="path-1" x="0" y="0" width="44" height="34" /> </defs> <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="winner-copy-5" transform="translate(-58.000000, -283.000000)"> <g id="Group-11" transform="translate(58.000000, 236.000000)"> <g id="Group-13" transform="translate(0.000000, 47.000000)"><path d="M0,0.990129262 C0,0.44329597 0.446521291,0 1.00019413,0 L106.999806,0 C107.552198,0 108,0.453369457 108,0.990129262 L108,73.0098707 C108,73.556704 107.553479,74 106.999806,74 L1.00019413,74 C0.447802166,74 0,73.5466305 0,73.0098707 L0,0.990129262 Z" id="Rectangle-47" /> <g id="Group-4" transform="translate(8.000000, 20.000000)"> <g id="Rectangle-122"> <use fill="#FDFDFD" fill-rule="evenodd" xlink:href="#path-1" id="use6" /> </g> <g id="g13" /></g> <rect id="rect16" x="11.1" y="24.9" width="84.900002" height="2.0999999" style="fill:#9e9e9e" /> <rect id="rect18" x="11.3" y="32.900002" width="84.300003" height="1.1000004" style="fill:#e0e0e0" /> <rect id="rect20" x="11.3" y="37.900002" width="84" height="0.99999845" style="fill:#e0e0e0" /> <rect id="rect22" x="11.5" y="42.900002" width="68.059998" height="1.1" style="fill:#e0e0e0" /></g></g></g></g></svg>`,
		definición: {
			columnas: [
				{
					partes: [
						{
							tipo: 'texto',
							texto: '',
							clases: {},
							estilos: {},
						}
					],
					clases: {},
					estilos: {
						'flex-grow': '1'
					}
				}
			],
			clases: {},
			estilos: {}
		}
	},
	{
		título: 'Imagen',
		ícono: 'mdi-image',
		//imagenSVG: `<svg xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" style="display: block;" width="108px" height="74px" viewBox="0 0 108 74" version="1.1" focusable="false" id="svg28" sodipodi:docname="pruebaSVG.svg" inkscape:version="0.92.3 (2405546, 2018-03-11)"><g id="Page-1" transform="translate(-2)" style="fill:none;fill-rule:evenodd;stroke:none;stroke-width:1"><g id="winner-copy-5" transform="translate(-58,-283)"><g id="Group-11" transform="translate(58,236)"><g id="Group-13" transform="translate(0,47)"><path d="M 0,0.99012926 C 0,0.44329597 0.44652129,0 1.0001941,0 H 106.99981 C 107.5522,0 108,0.45336946 108,0.99012926 V 73.009871 C 108,73.556704 107.55348,74 106.99981,74 H 1.0001941 C 0.44780217,74 0,73.546631 0,73.009871 Z" id="Rectangle-47" inkscape:connector-curvature="0" /><g id="Group-4" transform="translate(8,20)"><g id="Rectangle-122"><rect x="0.5" y="0.5" width="94.5" height="32.75" id="rect8" style="stroke:#979797;stroke-width:1;stroke-opacity:0.2" ry="0" /></g><g id="g13"><polygon id="Rectangle-624" points="14,22 17.730406,16.463382 19.656312,18.454068 24.030426,12 30.285714,22 " style="fill:#666666;fill-rule:evenodd" transform="translate(26)" /><circle id="Oval-10" cx="43.428574" cy="11.714286" r="1.7142857" style="fill:#666666;fill-rule:evenodd" /></g></g></g></g></g></g></svg>`,
		definición: {
			columnas: [
				{
					partes: [
						{
							tipo: 'imagen',
							ubicación: '',
							clases: {},
							estilos: {},
						}
					],
					clases: {},
					estilos: {
						'flex-grow': '1'
					}
				}
			],
			clases: {
				'imagenes-bordeadas': false,
				'imagenes-redondas': false,
			},
			estilos: {}
		}
	},
	{
		título: 'Mapa',
		ícono: 'mdi-map',
		definición: {
			columnas: [
				{
					partes: [
						{
							tipo: 'mapa',
							mapa: {
								coordenadas: {
									latitud: 4.6532724,
									longitud: -74.083836
								},
								distancia: 16
							},
							clases: {},
							estilos: {},
						}
					],
					clases: {},
					estilos: {}
				}
			],
			clases: {},
			estilos: {}
		}
	},
	{
		título: 'Formulario',
		ícono: 'mdi-form-select',
		definición: {
			columnas: [
				{
					partes: [
						{
							tipo: 'formulario',
							formulario: {
								identificador: (Math.random().toString(36).replace('0.', '') + Math.random().toString(36).replace('0.', '') + Math.random().toString(36).replace('0.', '')).substr(0, 20),
								título: 'Contáctenos',
								destinatario: '',
								elementos: [
									{ tipo: 'texto', título: 'Su nombre:', identificador: Math.random().toString().split('.')[1], },
									{ tipo: 'teléfono', título: 'Teléfono de contacto:', identificador: Math.random().toString().split('.')[1], },
									{ tipo: 'correo', título: 'Correo electrónico:', identificador: Math.random().toString().split('.')[1], },
									{ tipo: 'texto_largo', título: 'Déjenos su mensaje:', identificador: Math.random().toString().split('.')[1], }
								]
							},
							clases: {},
							estilos: {},
						}
					],
					clases: {},
					estilos: {}
				}
			],
			clases: {},
			estilos: {}
		}
	},
	{
		título: 'Línea separadora',
		ícono: 'mdi-minus',
		definición: {
			columnas: [
				{
					partes: [
						{
							tipo: 'separador',
							ubicación: '',
							clases: {},
							estilos: {},
						}
					],
					clases: {},
					estilos: {
						'flex-grow': '1'
					}
				}
			],
			clases: {},
			estilos: {}
		}
	},
	{
		descripción: 'Imagen a la izquierda y texto a la derecha',
		imagen: '',
		imagenSVG: '<svg style="display: block;" width="108px" height="74px" viewBox="0 0 108 74" version="1.1" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><rect id="path-1" x="0" y="0" width="44" height="34"></rect></defs><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="winner-copy-5" transform="translate(-58.000000, -283.000000)"><g id="Group-11" transform="translate(58.000000, 236.000000)"><g id="Group-13" transform="translate(0.000000, 47.000000)"><path d="M0,0.990129262 C0,0.44329597 0.446521291,0 1.00019413,0 L106.999806,0 C107.552198,0 108,0.453369457 108,0.990129262 L108,73.0098707 C108,73.556704 107.553479,74 106.999806,74 L1.00019413,74 C0.447802166,74 0,73.5466305 0,73.0098707 L0,0.990129262 Z" id="Rectangle-47"></path><g id="Group-4" transform="translate(8.000000, 20.000000)"><g id="Rectangle-122"><use fill="#FDFDFD" fill-rule="evenodd" xlink:href="#path-1"></use><rect stroke-opacity="0.2" stroke="#979797" stroke-width="1" x="0.5" y="0.5" width="43" height="33"></rect></g><g><polygon id="Rectangle-624" fill="#666666" fill-rule="evenodd" points="17.7304061 16.4633821 19.6563122 18.4540679 24.0304259 12 30.2857143 22 14 22"></polygon><circle id="Oval-10" fill="#666666" fill-rule="evenodd" cx="17.4285714" cy="11.7142857" r="1.71428571"></circle></g></g><rect id="Rectangle-122" fill="#9E9E9E" x="57" y="23" width="39" height="2"></rect><rect id="Rectangle-122" fill="#E0E0E0" x="57" y="31" width="43" height="1"></rect><rect id="Rectangle-122" fill="#E0E0E0" x="57" y="36" width="43" height="1"></rect><rect id="Rectangle-122" fill="#E0E0E0" x="57" y="41" width="22.5599995" height="1"></rect></g></g></g></g></svg>',
		definición: {
			columnas: [
				{
					partes: [
						{
							tipo: 'imagen',
							ubicación: '',
							clases: {},
							estilos: {},
						}
					],
					clases: {},
					estilos: {
						'flex-grow': '1'
					}
				},
				{
					partes: [
						{
							tipo: 'texto',
							texto: '',
							clases: {},
							estilos: {},
						}
					],
					clases: {},
					estilos: {
						'flex-grow': '1'
					}
				}
			],
			clases: {
				'imagenes-bordeadas': false,
				'imagenes-redondas': false,
				'hd14cm': true,
			},
			estilos: {}
		}
	},
	{
		descripción: 'Texto a la izquierda e imagen a la derecha',
		imagen: '',
		imagenSVG: `<svg xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" style="display: block;" width="108px" height="74px" viewBox="0 0 108 74" version="1.1" focusable="false" id="svg28" sodipodi:docname="pruebaSVG.svg" inkscape:version="0.92.3 (2405546, 2018-03-11)"><defs id="defs3"><rect id="path-1" x="0" y="0" width="44" height="34" /></defs><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="winner-copy-5" transform="translate(-58.000000, -283.000000)"><g id="Group-11" transform="translate(58.000000, 236.000000)"><g id="Group-13" transform="translate(0.000000, 47.000000)"><path d="M0,0.990129262 C0,0.44329597 0.446521291,0 1.00019413,0 L106.999806,0 C107.552198,0 108,0.453369457 108,0.990129262 L108,73.0098707 C108,73.556704 107.553479,74 106.999806,74 L1.00019413,74 C0.447802166,74 0,73.5466305 0,73.0098707 L0,0.990129262 Z" id="Rectangle-47" /><g id="Group-4" transform="translate(8.000000, 20.000000)"><g id="Rectangle-122"><use fill="#FDFDFD" fill-rule="evenodd" xlink:href="#path-1" id="use6" /><rect x="50.5" y="0.5" width="43" height="33" id="rect8" style="stroke:#979797;stroke-width:1;stroke-opacity:0.2" /></g><g id="g13"><polygon id="Rectangle-624" points="17.730406,16.463382 19.656312,18.454068 24.030426,12 30.285714,22 14,22 " transform="translate(50)" style="fill:#666666;fill-rule:evenodd" /><circle id="Oval-10" cx="67.428574" cy="11.714286" r="1.7142857" style="fill:#666666;fill-rule:evenodd" /></g></g><rect id="rect16" x="7" y="23" width="39" height="2" style="fill:#9e9e9e" /><rect id="rect18" x="7" y="31" width="43" height="1" style="fill:#e0e0e0" /><rect id="rect20" x="7" y="36" width="43" height="1" style="fill:#e0e0e0" /><rect id="rect22" x="7" y="41" width="22.559999" height="1" style="fill:#e0e0e0" /></g></g></g></g></svg>
		`,
		definición: {
			columnas: [
				{
					partes: [
						{
							tipo: 'texto',
							texto: '',
							clases: {},
							estilos: {},
						}
					],
					clases: {},
					estilos: {
						'flex-grow': '1'
					}
				},
				{
					partes: [
						{
							tipo: 'imagen',
							ubicación: '',
							clases: {},
							estilos: {},
						}
					],
					clases: {},
					estilos: {
						'flex-grow': '1'
					}
				}
			],
			clases: {
				'imagenes-bordeadas': false,
				'imagenes-redondas': false,
				'hd14cm': true,
			},
			estilos: {}
		}
	},
	{
		descripción: 'Dos columnas con imagen y texto',
		imagen: '',
		imagenSVG: '<svg style="display: block;" width="108px" height="74px" viewBox="0 0 108 74" version="1.1" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><rect id="path-1" x="0" y="0" width="44" height="26"></rect><rect id="path-2" x="0" y="0" width="44" height="34"></rect><rect id="path-3" x="0" y="0" width="44" height="34"></rect></defs><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="winner-copy-5" transform="translate(-174.000000, -283.000000)"><g id="Group-11" transform="translate(58.000000, 236.000000)"><g id="Group-14" transform="translate(116.000000, 47.000000)"><path d="M0,0.990129262 C0,0.44329597 0.446521291,0 1.00019413,0 L106.999806,0 C107.552198,0 108,0.453369457 108,0.990129262 L108,73.0098707 C108,73.556704 107.553479,74 106.999806,74 L1.00019413,74 C0.447802166,74 0,73.5466305 0,73.0098707 L0,0.990129262 Z" id="Rectangle-47"></path><rect id="Rectangle-122" fill="#9E9E9E" x="11" y="51" width="39" height="2"></rect><rect id="Rectangle-122" fill="#E0E0E0" x="11" y="59" width="39" height="1"></rect><rect id="Rectangle-122" fill="#E0E0E0" x="15" y="64" width="30" height="1"></rect><rect id="Rectangle-122" fill="#E0E0E0" x="59" y="59" width="39" height="1"></rect><rect id="Rectangle-122" fill="#E0E0E0" x="63" y="64" width="30" height="1"></rect><g id="Group-4" transform="translate(8.000000, 10.000000)"><g id="Rectangle-122"><use fill="#FDFDFD" fill-rule="evenodd" xlink:href="#path-1"></use><rect stroke-opacity="0.2" stroke="#979797" stroke-width="1" x="0.5" y="0.5" width="43" height="25"></rect></g><polygon id="Rectangle-624" fill="#666666" fill-rule="evenodd" points="17.7304061 13.4633821 19.6563122 15.4540679 24.0304259 9 30.2857143 19 14 19"></polygon><circle id="Oval-10" fill="#666666" fill-rule="evenodd" cx="17.4285714" cy="8.71428571" r="1.71428571"></circle></g><g id="Group-4" transform="translate(8.000000, 10.000000)"><g id="Rectangle-122"><use fill="#FDFDFD" fill-rule="evenodd" xlink:href="#path-2"></use><rect stroke-opacity="0.2" stroke="#979797" stroke-width="1" x="0.5" y="0.5" width="43" height="33"></rect></g><polygon id="Rectangle-624" fill="#666666" fill-rule="evenodd" points="17.7304061 16.4633821 19.6563122 18.4540679 24.0304259 12 30.2857143 22 14 22"></polygon><circle id="Oval-10" fill="#666666" fill-rule="evenodd" cx="17.4285714" cy="11.7142857" r="1.71428571"></circle></g><g id="Group-4" transform="translate(56.000000, 10.000000)"><g id="Rectangle-122"><use fill="#FDFDFD" fill-rule="evenodd" xlink:href="#path-3"></use><rect stroke-opacity="0.2" stroke="#979797" stroke-width="1" x="0.5" y="0.5" width="43" height="33"></rect></g><polygon id="Rectangle-624" fill="#666666" fill-rule="evenodd" points="17.7304061 16.4633821 19.6563122 18.4540679 24.0304259 12 30.2857143 22 14 22"></polygon><circle id="Oval-10" fill="#666666" fill-rule="evenodd" cx="17.4285714" cy="11.7142857" r="1.71428571"></circle></g><rect id="Rectangle-122" fill="#9E9E9E" x="59" y="51" width="39" height="2"></rect></g></g></g></g></svg>',
		definición: {
			columnas: [
				{
					partes: [
						{
							tipo: 'imagen',
							ubicación: '',
							clases: {},
							estilos: {},
						},
						{
							tipo: 'texto',
							texto: '',
							clases: {},
							estilos: {},
						}
					],
					clases: {},
					estilos: {
						'flex-grow': '1'
					}
				},
				{
					partes: [
						{
							tipo: 'imagen',
							ubicación: '',
							clases: {},
							estilos: {},
						},
						{
							tipo: 'texto',
							texto: '',
							clases: {},
							estilos: {},
						}
					],
					clases: {},
					estilos: {
						'flex-grow': '1'
					}
				}
			],
			clases: {
				'imagenes-bordeadas': false,
				'imagenes-redondas': false,
				'hd18cm': true,
			},
			estilos: {}
		}
	},
	{
		descripción: 'Tres columnas con imagen y texto',
		imagen: '',
		imagenSVG: '<svg style="display: block;" width="108px" height="74px" viewBox="0 0 108 74" version="1.1" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><rect id="path-1" x="0" y="0" width="24" height="24"></rect><rect id="path-2" x="0" y="0" width="24" height="24"></rect><rect id="path-3" x="0" y="0" width="24" height="24"></rect><path d="M0,0.990129262 C0,0.44329597 0.446521291,0 1.00019413,0 L106.999806,0 C107.552198,0 108,0.453369457 108,0.990129262 L108,73.0098707 C108,73.556704 107.553479,74 106.999806,74 L1.00019413,74 C0.447802166,74 0,73.5466305 0,73.0098707 L0,0.990129262 Z" id="rect-1"></path></defs><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="winner-copy-5" transform="translate(-174.000000, -365.000000)"><g id="Group-11" transform="translate(58.000000, 236.000000)"><g id="Group-17" transform="translate(116.000000, 129.000000)"><g id="Rectangle-47"><use fill-opacity="0" fill="#FFFFFF" fill-rule="evenodd" xlink:href="#rect-1"></use></g><g id="Group-3" transform="translate(8.000000, 13.000000)"><g id="Rectangle-122"><rect stroke-opacity="0.2" stroke="#979797" stroke-width="1" x="0.5" y="0.5" width="23" height="23"></rect></g><polygon id="Rectangle-624" fill="#666666" fill-rule="evenodd" points="8.67824028 12.1243675 10.0609421 13.5178475 13.2013314 9 17.6923077 16 6 16"></polygon><circle id="Oval-10" fill="#666666" fill-rule="evenodd" cx="8.46153846" cy="8.23076923" r="1.23076923"></circle></g><rect id="Rectangle-122" fill="#9E9E9E" x="8" y="43" width="24" height="2"></rect><rect id="Rectangle-122" fill="#E0E0E0" x="8" y="51" width="24" height="1"></rect><rect id="Rectangle-122" fill="#E0E0E0" x="8" y="56" width="24" height="1"></rect><g id="Group-3" transform="translate(42.000000, 13.000000)"><g id="Rectangle-122"><rect stroke-opacity="0.2" stroke="#979797" stroke-width="1" x="0.5" y="0.5" width="23" height="23"></rect></g><polygon id="Rectangle-624" fill="#666666" fill-rule="evenodd" points="8.67824028 12.1243675 10.0609421 13.5178475 13.2013314 9 17.6923077 16 6 16"></polygon><circle id="Oval-10" fill="#666666" fill-rule="evenodd" cx="8.46153846" cy="8.23076923" r="1.23076923"></circle></g><rect id="Rectangle-122" fill="#9E9E9E" x="42" y="43" width="24" height="2"></rect><rect id="Rectangle-122" fill="#E0E0E0" x="42" y="51" width="24" height="1"></rect><rect id="Rectangle-122" fill="#E0E0E0" x="42" y="56" width="24" height="1"></rect><g id="Group-3" transform="translate(76.000000, 13.000000)"><g id="Rectangle-122"><rect stroke-opacity="0.2" stroke="#979797" stroke-width="1" x="0.5" y="0.5" width="23" height="23"></rect></g><polygon id="Rectangle-624" fill="#666666" fill-rule="evenodd" points="8.67824028 12.1243675 10.0609421 13.5178475 13.2013314 9 17.6923077 16 6 16"></polygon><circle id="Oval-10" fill="#666666" fill-rule="evenodd" cx="8.46153846" cy="8.23076923" r="1.23076923"></circle></g><rect id="Rectangle-122" fill="#9E9E9E" x="76" y="43" width="24" height="2"></rect><rect id="Rectangle-122" fill="#E0E0E0" x="76" y="51" width="24" height="1"></rect><rect id="Rectangle-122" fill="#E0E0E0" x="76" y="56" width="24" height="1"></rect><rect id="Rectangle-122" fill="#E0E0E0" x="11" y="61" width="18" height="1"></rect><rect id="Rectangle-122" fill="#E0E0E0" x="45" y="61" width="18" height="1"></rect><rect id="Rectangle-122" fill="#E0E0E0" x="79" y="61" width="18" height="1"></rect></g></g></g></g></svg>',
		definición: {
			columnas: [
				{
					partes: [
						{
							tipo: 'imagen',
							ubicación: '',
							clases: {},
							estilos: {},
						},
						{
							tipo: 'texto',
							texto: '',
							clases: {},
							estilos: {},
						}
					],
					clases: {},
					estilos: {
						'flex-grow': '1'
					}
				},
				{
					partes: [
						{
							tipo: 'imagen',
							ubicación: '',
							clases: {},
							estilos: {},
						},
						{
							tipo: 'texto',
							texto: '',
							clases: {},
							estilos: {},
						}
					],
					clases: {},
					estilos: {
						'flex-grow': '1'
					}
				},
				{
					partes: [
						{
							tipo: 'imagen',
							ubicación: '',
							clases: {},
							estilos: {},
						},
						{
							tipo: 'texto',
							texto: '',
							clases: {},
							estilos: {},
						}
					],
					clases: {},
					estilos: {
						'flex-grow': '1'
					}
				}
			],
			clases: {
				'imagenes-bordeadas': false,
				'imagenes-redondas': false,
				'hd22cm': true,
			},
			estilos: {}
		}
	},
	{
		descripción: 'Cuatro columnas con imagen y texto',
		imagen: '',
		imagenSVG: '<svg style="display: block;" width="108px" height="74px" viewBox="0 0 108 74" version="1.1" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><rect id="path-1" x="0" y="0" width="22" height="22"></rect><rect id="path-2" x="0" y="0" width="22" height="22"></rect><rect id="path-3" x="0" y="0" width="22" height="22"></rect><rect id="path-4" x="0" y="0" width="22" height="22"></rect></defs><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="L-to-R" transform="translate(-58.000000, -447.000000)"><g id="Group-5" transform="translate(58.000000, 447.000000)"><path d="M0,0.990129262 C0,0.44329597 0.446521291,0 1.00019413,0 L106.999806,0 C107.552198,0 108,0.453369457 108,0.990129262 L108,73.0098707 C108,73.556704 107.553479,74 106.999806,74 L1.00019413,74 C0.447802166,74 0,73.5466305 0,73.0098707 L0,0.990129262 Z" id="Rectangle-47"></path><g id="Group-10" transform="translate(5.000000, 24.000000)"><g id="Group-6"><g id="Group-21"><g id="Rectangle"><rect stroke-opacity="0.2" stroke="#979797" stroke-width="1" x="0.5" y="0.5" width="21" height="21"></rect></g><polygon id="Rectangle-624" fill="#666666" fill-rule="evenodd" points="7.67824028 10.1243675 9.06094211 11.5178475 12.2013314 7 16.6923077 14 5 14"></polygon><circle id="Oval-10" fill="#666666" fill-rule="evenodd" cx="7.23076923" cy="7.23076923" r="1.23076923"></circle></g><g id="Group-21" transform="translate(50.000000, 0.000000)"><g id="Rectangle"><rect stroke-opacity="0.2" stroke="#979797" stroke-width="1" x="0.5" y="0.5" width="21" height="21"></rect></g><polygon id="Rectangle-624" fill="#666666" fill-rule="evenodd" points="7.67824028 10.1243675 9.06094211 11.5178475 12.2013314 7 16.6923077 14 5 14"></polygon><circle id="Oval-10" fill="#666666" fill-rule="evenodd" cx="7.23076923" cy="7.23076923" r="1.23076923"></circle></g><g id="Group-21" transform="translate(75.000000, 0.000000)"><g id="Rectangle"><rect stroke-opacity="0.2" stroke="#979797" stroke-width="1" x="0.5" y="0.5" width="21" height="21"></rect></g><polygon id="Rectangle-624" fill="#666666" fill-rule="evenodd" points="7.67824028 10.1243675 9.06094211 11.5178475 12.2013314 7 16.6923077 14 5 14"></polygon><circle id="Oval-10" fill="#666666" fill-rule="evenodd" cx="7.23076923" cy="7.23076923" r="1.23076923"></circle></g><rect id="Rectangle-2" fill="#9E9E9E" x="5" y="25" width="12" height="1"></rect><rect id="Rectangle-2" fill="#9E9E9E" x="30" y="25" width="12" height="1"></rect><rect id="Rectangle-2" fill="#9E9E9E" x="55" y="25" width="12" height="1"></rect><rect id="Rectangle-2" fill="#9E9E9E" x="80" y="25" width="12" height="1"></rect><g id="Group-21" transform="translate(25.000000, 0.000000)"><g id="Rectangle"><rect stroke-opacity="0.2" stroke="#979797" stroke-width="1" x="0.5" y="0.5" width="21" height="21"></rect></g><polygon id="Rectangle-624" fill="#666666" fill-rule="evenodd" points="7.67824028 10.1243675 9.06094211 11.5178475 12.2013314 7 16.6923077 14 5 14"></polygon><circle id="Oval-10" fill="#666666" fill-rule="evenodd" cx="7.23076923" cy="7.23076923" r="1.23076923"></circle></g></g></g></g></g></g></svg>',
		definición: {
			columnas: [
				{
					partes: [
						{
							tipo: 'imagen',
							ubicación: '',
							clases: {},
							estilos: {},
						},
						{
							tipo: 'texto',
							texto: '',
							clases: {},
							estilos: {},
						}
					],
					clases: {},
					estilos: {
						'flex-grow': '1'
					}
				},
				{
					partes: [
						{
							tipo: 'imagen',
							ubicación: '',
							clases: {},
							estilos: {},
						},
						{
							tipo: 'texto',
							texto: '',
							clases: {},
							estilos: {},
						}
					],
					clases: {},
					estilos: {
						'flex-grow': '1'
					}
				},
				{
					partes: [
						{
							tipo: 'imagen',
							ubicación: '',
							clases: {},
							estilos: {},
						},
						{
							tipo: 'texto',
							texto: '',
							clases: {},
							estilos: {},
						}
					],
					clases: {},
					estilos: {
						'flex-grow': '1'
					}
				},
				{
					partes: [
						{
							tipo: 'imagen',
							ubicación: '',
							clases: {},
							estilos: {},
						},
						{
							tipo: 'texto',
							texto: '',
							clases: {},
							estilos: {},
						}
					],
					clases: {},
					estilos: {
						'flex-grow': '1'
					}
				}
			],
			clases: {
				'imagenes-bordeadas': false,
				'imagenes-redondas': false,
				'hd25cm': true,
			},
			estilos: {}
		}
	},
	{
		descripción: 'Cuatro columnas de imagen y texto intercaladas',
		imagen: '',
		imagenSVG: '<svg style="display: block;" width="108px" height="74px" viewBox="0 0 108 74" version="1.1" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><rect id="path-1" x="0" y="0" width="18" height="18"></rect><rect id="path-2" x="0" y="0" width="18" height="18"></rect></defs><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="L-to-R" transform="translate(-58.000000, -365.000000)"><g id="Group-11" transform="translate(58.000000, 236.000000)"><g id="Group-15" transform="translate(0.000000, 129.000000)"><path d="M0,0.990129262 C0,0.44329597 0.446521291,0 1.00019413,0 L106.999806,0 C107.552198,0 108,0.453369457 108,0.990129262 L108,73.0098707 C108,73.556704 107.553479,74 106.999806,74 L1.00019413,74 C0.447802166,74 0,73.5466305 0,73.0098707 L0,0.990129262 Z" id="Rectangle-47"></path><g id="Group-21" transform="translate(8.000000, 26.000000)"><g id="Rectangle"><rect stroke-opacity="0.2" stroke="#979797" stroke-width="1" x="0.5" y="0.5" width="17" height="17"></rect></g><g><polygon id="Rectangle-624" fill="#666666" fill-rule="evenodd" points="7.10037841 8.28357339 8.23167991 9.42369344 10.8010893 5.72727273 14.4755245 11.4545455 4.90909091 11.4545455"></polygon><circle id="Oval-10" fill="#666666" fill-rule="evenodd" cx="6.73426573" cy="5.91608392" r="1.00699301"></circle></g></g><rect id="Rectangle-122" fill="#9E9E9E" x="30" y="28" width="15" height="2"></rect><rect id="Rectangle-122" fill="#E0E0E0" x="30" y="36" width="20" height="1"></rect><rect id="Rectangle-122" fill="#E0E0E0" x="30" y="41" width="20" height="1"></rect><g id="Group-21" transform="translate(57.000000, 26.000000)"><g id="Rectangle"><rect stroke-opacity="0.2" stroke="#979797" stroke-width="1" x="0.5" y="0.5" width="17" height="17"></rect></g><g><polygon id="Rectangle-624" fill="#666666" fill-rule="evenodd" points="7.10037841 8.28357339 8.23167991 9.42369344 10.8010893 5.72727273 14.4755245 11.4545455 4.90909091 11.4545455"></polygon><circle id="Oval-10" fill="#666666" fill-rule="evenodd" cx="6.73426573" cy="5.91608392" r="1.00699301"></circle></g></g><rect id="Rectangle-122" fill="#9E9E9E" x="80" y="28" width="15" height="2"></rect><rect id="Rectangle-122" fill="#E0E0E0" x="80" y="36" width="20" height="1"></rect><rect id="Rectangle-122" fill="#E0E0E0" x="80" y="41" width="20" height="1"></rect></g></g></g></g></svg>',
		definición: {
			columnas: [
				{
					partes: [
						{
							tipo: 'imagen',
							ubicación: '',
							clases: {},
							estilos: {},
						}
					],
					clases: {},
					estilos: {
						'flex-grow': '1'
					}
				},
				{
					partes: [
						{
							tipo: 'texto',
							texto: '',
							clases: {},
							estilos: {},
						}
					],
					clases: {},
					estilos: {
						'flex-grow': '1'
					}
				},
				{
					partes: [
						{
							tipo: 'imagen',
							ubicación: '',
							clases: {},
							estilos: {},
						}
					],
					clases: {},
					estilos: {
						'flex-grow': '1'
					}
				},
				{
					partes: [
						{
							tipo: 'texto',
							texto: '',
							clases: {},
							estilos: {},
						}
					],
					clases: {},
					estilos: {
						'flex-grow': '1'
					}
				}
			],
			clases: {
				'imagenes-bordeadas': false,
				'imagenes-redondas': false,
				'hd25cm': true,
			},
			estilos: {}
		}
	},
	{
		descripción: 'Imagen a la izquierda y formulario a la derecha',
		imagen: '',
		imagenSVG: '<svg style="display: block;" width="108px" height="74px" viewBox="0 0 108 74" version="1.1" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><rect id="path-1" x="0" y="0" width="44" height="34"></rect></defs><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="winner-copy-5" transform="translate(-58.000000, -283.000000)"><g id="Group-11" transform="translate(58.000000, 236.000000)"><g id="Group-13" transform="translate(0.000000, 47.000000)"><path d="M0,0.990129262 C0,0.44329597 0.446521291,0 1.00019413,0 L106.999806,0 C107.552198,0 108,0.453369457 108,0.990129262 L108,73.0098707 C108,73.556704 107.553479,74 106.999806,74 L1.00019413,74 C0.447802166,74 0,73.5466305 0,73.0098707 L0,0.990129262 Z" id="Rectangle-47"></path><g id="Group-4" transform="translate(8.000000, 20.000000)"><g id="Rectangle-122"><use fill="#FDFDFD" fill-rule="evenodd" xlink:href="#path-1"></use><rect stroke-opacity="0.2" stroke="#979797" stroke-width="1" x="0.5" y="0.5" width="43" height="33"></rect></g><g><polygon id="Rectangle-624" fill="#666666" fill-rule="evenodd" points="17.7304061 16.4633821 19.6563122 18.4540679 24.0304259 12 30.2857143 22 14 22"></polygon><circle id="Oval-10" fill="#666666" fill-rule="evenodd" cx="17.4285714" cy="11.7142857" r="1.71428571"></circle></g></g><rect id="Rectangle-122" fill="#9E9E9E" x="57" y="23" width="39" height="2"></rect><rect id="Rectangle-122" fill="#E0E0E0" x="57" y="31" width="43" height="1"></rect><rect id="Rectangle-122" fill="#E0E0E0" x="57" y="36" width="43" height="1"></rect><rect id="Rectangle-122" fill="#E0E0E0" x="57" y="41" width="22.5599995" height="1"></rect></g></g></g></g></svg>',
		definición: {
			columnas: [
				{
					partes: [
						{
							tipo: 'imagen',
							ubicación: '',
							clases: {},
							estilos: {},
						}
					],
					clases: {},
					estilos: {
						'flex-grow': '1'
					}
				},
				{
					partes: [
						{
							tipo: 'formulario',
							formulario: {
								identificador: (Math.random().toString(36).replace('0.', '') + Math.random().toString(36).replace('0.', '') + Math.random().toString(36).replace('0.', '')).substr(0, 20),
								título: 'Contáctenos',
								destinatario: '',
								elementos: [
									{ tipo: 'texto', título: 'Su nombre:', identificador: Math.random().toString().split('.')[1], },
									{ tipo: 'teléfono', título: 'Teléfono de contacto:', identificador: Math.random().toString().split('.')[1], },
									{ tipo: 'correo', título: 'Correo electrónico:', identificador: Math.random().toString().split('.')[1], },
									{ tipo: 'texto_largo', título: 'Déjenos su mensaje:', identificador: Math.random().toString().split('.')[1], }
								]
							},
							clases: {},
							estilos: {},
						}
					],
					clases: {},
					estilos: {
						'flex-grow': '1'
					}
				}
			],
			clases: {
				'imagenes-bordeadas': true,
				'imagenes-redondas': false,
				'hd14cm': true,
			},
			estilos: {}
		}
	},
	{
		descripción: 'Mapa a la izquierda y formulario a la derecha',
		imagen: '',
		imagenSVG: '<svg style="display: block;" width="108px" height="74px" viewBox="0 0 108 74" version="1.1" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><rect id="path-1" x="0" y="0" width="44" height="34"></rect></defs><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="winner-copy-5" transform="translate(-58.000000, -283.000000)"><g id="Group-11" transform="translate(58.000000, 236.000000)"><g id="Group-13" transform="translate(0.000000, 47.000000)"><path d="M0,0.990129262 C0,0.44329597 0.446521291,0 1.00019413,0 L106.999806,0 C107.552198,0 108,0.453369457 108,0.990129262 L108,73.0098707 C108,73.556704 107.553479,74 106.999806,74 L1.00019413,74 C0.447802166,74 0,73.5466305 0,73.0098707 L0,0.990129262 Z" id="Rectangle-47"></path><g id="Group-4" transform="translate(8.000000, 20.000000)"><g id="Rectangle-122"><use fill="#FDFDFD" fill-rule="evenodd" xlink:href="#path-1"></use><rect stroke-opacity="0.2" stroke="#979797" stroke-width="1" x="0.5" y="0.5" width="43" height="33"></rect></g><g><polygon id="Rectangle-624" fill="#666666" fill-rule="evenodd" points="17.7304061 16.4633821 19.6563122 18.4540679 24.0304259 12 30.2857143 22 14 22"></polygon><circle id="Oval-10" fill="#666666" fill-rule="evenodd" cx="17.4285714" cy="11.7142857" r="1.71428571"></circle></g></g><rect id="Rectangle-122" fill="#9E9E9E" x="57" y="23" width="39" height="2"></rect><rect id="Rectangle-122" fill="#E0E0E0" x="57" y="31" width="43" height="1"></rect><rect id="Rectangle-122" fill="#E0E0E0" x="57" y="36" width="43" height="1"></rect><rect id="Rectangle-122" fill="#E0E0E0" x="57" y="41" width="22.5599995" height="1"></rect></g></g></g></g></svg>',
		definición: {
			columnas: [
				{
					partes: [
						{
							tipo: 'mapa',
							mapa: {
								coordenadas: {
									latitud: 4.6532724,
									longitud: -74.083836
								},
								distancia: 16
							},
							clases: {},
							estilos: {},
						}
					],
					clases: {},
					estilos: {
						'width': '100%',
						'flex-grow': '1'
					}
				},
				{
					partes: [
						{
							tipo: 'formulario',
							formulario: {
								identificador: (Math.random().toString(36).replace('0.', '') + Math.random().toString(36).replace('0.', '') + Math.random().toString(36).replace('0.', '')).substr(0, 20),
								título: 'Contáctenos',
								destinatario: '',
								elementos: [
									{ tipo: 'texto', título: 'Su nombre:', identificador: Math.random().toString().split('.')[1], },
									{ tipo: 'teléfono', título: 'Teléfono de contacto:', identificador: Math.random().toString().split('.')[1], },
									{ tipo: 'correo', título: 'Correo electrónico:', identificador: Math.random().toString().split('.')[1], },
									{ tipo: 'texto_largo', título: 'Déjenos su mensaje:', identificador: Math.random().toString().split('.')[1], }
								]
							},
							clases: {},
							estilos: {},
						}
					],
					clases: {},
					estilos: {
						'flex-grow': '1'
					}
				}
			],
			clases: {
				'hd14cm': true,
			},
			estilos: {}
		}
	},
]

